<template>
  <div class="card trip" @click="router.push({
    name: 'searchFromToCityDate', params: {
      startCity:
        trip.addressToStart.city.slug, endCity: trip.addressToEnd.city.slug, date: trip.timeToStart.split(' ')[0]
    }
  })">

    <div class="trip-body" :style="trip.thumbnailName
      ? { backgroundImage: `url(${config.apiUrl}/uploads/thumbnails/${trip.thumbnailName})` }
      : {}">
      <div class="company">
        <img v-if="trip.company.logoName" :src="`${config.apiUrl}/uploads/logos/${trip.company.logoName}`"
          :alt="trip.company.name" />
        <span v-else>{{ trip.company.name }}</span>
      </div>

      <div class="cities">
        <span class="city-from">{{ trip.addressToStart.city.name }}</span>
        <span class="city-to">{{ trip.addressToEnd.city.name }}</span>
      </div>
    </div>

    <div class="trip-footer">
      <span class="date">{{ formattedDate }}</span>
      <div class="price">
        <span class="label">à partir de</span>
        <span class="amount">{{ localeStore.formatPrice(trip.price) }}</span>
      </div>
    </div>

  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { config } from '@/config/env.js'
import { useLocaleStore } from '@/stores/localeStore'

const props = defineProps({
  trip: { type: Object, required: true }
})

const router = useRouter()
const localeStore = useLocaleStore()

const formattedDate = computed(() => {
  if (!props.trip.timeToStart) return ''
  const date = new Date(props.trip.timeToStart)
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })
})
</script>

<style scoped>
/* === BODY avec image === */
.trip-body {
  position: relative;
  height: 180px;
  background: var(--color-grey-light) center / cover no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.75rem;
}

/* Fondu bas uniquement */
.trip-body::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 40%, rgba(0, 0, 0, 0.65) 100%);
  pointer-events: none;
}

/* Enfants au-dessus de l'overlay */
.trip-body>* {
  position: relative;
  z-index: 1;
}

/* Logo / nom — haut droite */
.company {
  align-self: flex-end;
  background: var(--bg-primary-alpha);
  padding: 0.2rem 0.5rem;
  border-radius: var(--border-radius-sm);
}

.company img {
  height: 30px;
  width: auto;
  max-width: 110px;
  object-fit: contain;
  display: block;
}

.company span {
  font-size: 0.8rem;
  font-weight: 700;
  color: #333;
}

/* Villes — bas gauche */
.cities {
  display: flex;
  flex-direction: column;
}

.city-from {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.75);
  text-transform: capitalize;
}

.city-to {
  font-size: 1.6rem;
  font-weight: 900;
  color: var(--bg-primary);
  line-height: 1.1;
  text-transform: capitalize;
}

/* === FOOTER === */
.trip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.75rem;
  border-top: 1px solid var(--color-border);
}

.date {
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  text-transform: capitalize;
}

.price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.price .label {
  font-size: 0.7rem;
  color: var(--color-text-secondary);
}

.price .amount {
  font-size: 1.4rem;
  font-weight: 900;
  color: var(--color-feuille);
  line-height: 1;
}
</style>
